/**
 * Social component
 * ----------------
 */

/* Imports */

import React from "react";
import { Social } from "./styles.module.scss";

/* Component */

const SocialComponent = ({ title = "", link = "" }) => {
  return (
    <a className={`${Social} lc-social lc-p-r`} href={link}>
      <div className="lc-v-h">{title}</div>
      <img
        src={`../../../../latercon/2021/svg/logos/sm/${title.toLowerCase()}.svg`}
        alt=""
      />
    </a>
  );
};

/* Export */

export default SocialComponent;
